module.exports = __webpack_public_path__ + "media/images/athletes/2204-8d4e52032fd1209c6fbf519801f5cb9e.png";